import {
  leadsLogsListQueryKey,
  leadsTasksListQueryKey,
  opportunitiesLogsListQueryKey,
  opportunitiesTasksListQueryKey,
  ReturnTaskReadable,
  tasksListQueryKey,
  tasksPartialUpdateMutation
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'

import { useMutation } from '@tanstack/react-query'

type Props = {
  task: ReturnTaskReadable | null
  onCancel: () => void
}

export const UnCompleteTask = ({ task, onCancel, ...props }: Props) => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { mutate, isPending } = useMutation({
    ...tasksPartialUpdateMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsTasksListQueryKey({
          path: {
            lead_id: String(task?.lead?.id)
          }
        }),
        leadsLogsListQueryKey({
          path: {
            lead_id: String(task?.lead?.id)
          }
        }),
        opportunitiesTasksListQueryKey({
          path: {
            opportunity_id: String(task?.opportunity?.id)
          }
        }),
        opportunitiesLogsListQueryKey({
          path: {
            opportunity_id: String(task?.opportunity?.id)
          }
        }),
        tasksListQueryKey()
      ])
      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const onEdit = () => {
    if (!task?.id) return

    mutate({
      path: { id: task.id },
      body: { title: task.title, completed_at: null }
    })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={onEdit}
      onCancel={onCancel}
      {...props}
    >
      {t('task.areYouSureUncompleteDescription')}
    </ConfirmModal>
  )
}
